var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { withTheme } from 'emotion-theming';
import * as React from 'react';
import styled, { css } from 'react-emotion';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { constructGallery } from './constructGallery';
import Image from '@jetshop/ui/Image/Image';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import get from 'lodash.get';
const Wrapper = styled('div') `
  position: relative;
  img {
    max-height: 100vh;
  }
  .image-gallery-image {
    text-align: center;
  }
  .image-gallery-thumbnail-inner {
    font-size: 10px;
  }
  .image-gallery-right-nav,
  .image-gallery-left-nav,
  .image-gallery-fullscreen-button {
    z-index: 2;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    transition: background 0.3s ease-in-out;
    margin: 0 0.5rem;
    &:hover {
      background: rgba(255, 255, 255, 0.8);
    }
    &:before {
      color: black;
      text-shadow: none;
    }
  }
  .image-gallery-fullscreen-button {
    margin-bottom: 0.5rem;
  }
  .image-gallery-fullscreen-button:before {
    text-shadow: none;
    font-size: 0.7em;
    padding: 0;
  }
  .image-gallery-thumbnail.active {
    border-width: 1px;
  }
  .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails,
  .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .fullscreen {
    .image-gallery-fullscreen-button {
      margin: 2rem;
    }
    .image-gallery-right-nav,
    .image-gallery-left-nav {
      margin: 0 2rem;
    }
    img {
      width: auto;
      max-width: 100%;
    }
    .image-gallery-thumbnails-wrapper {
      display: none;
    }
  }
`;
const Overlay = styled('div') `
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;
const Gallery = function Gallery(props) {
    const { sizes = [1, 1, 1 / 2, 1 / 2], fullScreenSizes = [1, 1, 1, 1], thumbnailSizes = ['5rem'], aspect = '1:1', thumbnailPosition = 'bottom', backgroundColor = 'white', thumbnailQuality, quality, images, theme, galleryRef } = props, rest = __rest(props, ["sizes", "fullScreenSizes", "thumbnailSizes", "aspect", "thumbnailPosition", "backgroundColor", "thumbnailQuality", "quality", "images", "theme", "galleryRef"]);
    const { selectedChannel } = React.useContext(ChannelContext);
    const baseUrl = get(selectedChannel, 'url')
        ? String(selectedChannel.url)
        : null;
    const [isFullscreen, setFullscreen] = React.useState(false);
    const galleryImages = React.useMemo(() => constructGallery(images, theme, fullScreenSizes, aspect, baseUrl), [aspect, baseUrl, fullScreenSizes, images, theme]);
    return (React.createElement(Wrapper, { className: `${css `
        .image-gallery-slide {
          background-color: ${backgroundColor};
        }
      `}` },
        React.createElement(ImageGallery, Object.assign({ ref: r => (galleryRef ? (galleryRef.current = r) : null), thumbnailPosition: thumbnailPosition, items: galleryImages, autoPlay: false, showPlayButton: false, showThumbnails: galleryImages.length > 1, useBrowserFullscreen: false, preventDefaultTouchmoveEvent: isFullscreen, onScreenChange: el => setFullscreen(!!el), renderItem: item => {
                return (React.createElement("div", { className: "image-gallery-image" }, isFullscreen ? (React.createElement("img", { src: item.original, alt: item.originalAlt, srcSet: item.srcSet, sizes: item.sizes, title: item.originalTitle })) : (React.createElement(React.Fragment, null,
                    React.createElement(Image, { src: item.original, alt: item.originalAlt, sizes: sizes, title: item.originalTitle, aspect: aspect, quality: quality, modifiedDate: item.modifiedDate }),
                    props.children && React.createElement(Overlay, null, props.children)))));
            }, renderThumbInner: item => {
                return (React.createElement("div", { className: "image-gallery-thumbnail-inner" },
                    React.createElement(Image, { src: item.thumbnail, alt: item.thumbnailAlt, title: item.thumbnailTitle, sizes: thumbnailSizes, aspect: aspect, quality: thumbnailQuality }),
                    item.thumbnailLabel && (React.createElement("div", { className: "image-gallery-thumbnail-label" }, item.thumbnailLabel))));
            } }, rest))));
};
export default withTheme(Gallery);
//# sourceMappingURL=Gallery.js.map